import React from 'react';

import {
    CollapsibleContent,
    CollapsibleContentFull,
    CollapsibleContentIntro,
} from '@dndbeyond/character-common-components/es';

import { appEnvSelectors } from '../../../../Shared/selectors';
import Page from '../../../components/Page';
import PageBody from '../../../components/PageBody';
import PageHeader from '../../../components/PageHeader';
import { RouteKey } from '../../../constants/navigation';
import { BuilderAppState } from '../../../typings';
import ConnectedBuilderPage from '../ConnectedBuilderPage';

interface Props {
    isMobile: boolean;
}
class ClassHelp extends React.PureComponent<Props> {
    render() {
        const { isMobile } = this.props;

        return (
            <Page>
                <PageBody>
                    <PageHeader>Choose a Class</PageHeader>

                    <CollapsibleContent forceShow={!isMobile}>
                        <CollapsibleContentIntro>
                            <p>
                                In the next step, choose a class for your character. Every adventurer is a member of a
                                class. Class broadly describes a character's vocation, what special talents he or she
                                possesses, and the tactics he or she is most likely to employ when exploring a dungeon,
                                fighting monsters, or engaging in a tense negotiation.
                            </p>
                        </CollapsibleContentIntro>
                        <CollapsibleContentFull>
                            <p>
                                Your character receives a number of benefits from your choice of class. Many of these
                                benefits are class features - capabilities (including spellcasting) that set your
                                character apart from members of other classes. You also gain a number of proficiencies:
                                armor, weapons, skills, saving throws, and sometimes tools. Your proficiencies define
                                many of the things your character can do particularly well, from using certain weapons
                                to telling a convincing lie.
                            </p>
                        </CollapsibleContentFull>
                    </CollapsibleContent>

                    <PageHeader>Multiclassing</PageHeader>

                    <p>
                        Adventurers sometimes advance in more than one class. A rogue might switch direction in life and
                        swear the oath of a paladin, A barbarian might discover latent magical ability and dabble in the
                        sorcerer class while continuing to advance as a barbarian. Elves are known to combine martial
                        mastery with magical training and advance as fighters and wizards simultaneously.
                    </p>

                    <p>The optional rules for combining classes in this way is called Multiclassing.</p>
                </PageBody>
            </Page>
        );
    }
}

export default ConnectedBuilderPage(ClassHelp, RouteKey.CLASS_HELP, (state: BuilderAppState) => {
    return {
        isMobile: appEnvSelectors.getIsMobile(state),
    };
});
